export default __webpack_public_path__ + "static/media/cross.c798b62b.svg";